import React from 'react';
import {
  Skeleton, Box, Grid, Container,
} from '@mui/material';

const AdditionalInformationSectionSkeleton: React.FC = () => (
  <Box py={10}>
    <Container maxWidth="xl">
      <Box my={2}>
        <Skeleton variant="text" width="300px" height={80} />
      </Box>

      <Grid container spacing={2}>
        {[...Array(9).keys()].map((item) => (
          <Grid item md={4} sm={12} key={item}>
            <Skeleton variant="text" width="80%" height={20} />
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export { AdditionalInformationSectionSkeleton };

